export type { RequestConfig, ResponseConfig, ResponseErrorConfig } from './config'
import { BASE_API_GATEWAY_URL } from '../endpoints.constants'
import { createClient } from './config'

export default createClient(BASE_API_GATEWAY_URL, false)
